import { useContext } from 'react'

import { ParamsCenterContext } from '@provider/Config/ParamsCenterProvider'

import { IParamsCenterContext } from '@base/@types/providers/Config/ParamsCenterProvider'

export default function useParamsCenter(): IParamsCenterContext {
  const context = useContext(ParamsCenterContext)

  return context
}
